import React from 'react';

import { cn } from './utils';


const LEVELS = [
  { label: '', bar: 'bg-hairline-strong', text: 'text-ink-subtle' },
  { label: 'Weak', bar: 'bg-danger', text: 'text-danger' },
  { label: 'Fair', bar: 'bg-warning', text: 'text-warning' },
  { label: 'Good', bar: 'bg-primary', text: 'text-primary' },
  { label: 'Strong', bar: 'bg-success', text: 'text-success' },
];

/** Rules-based score 0–4 (client-side hint only; the server enforces real policy). */
export function scorePassword(value = '') {
  if (!value) {
    return 0;
  }

  let score = 0;
  if (value.length >= 8) {
    score += 1;
  }
  if (value.length >= 12) {
    score += 1;
  }
  if ((/[a-z]/).test(value) && (/[A-Z]/).test(value)) {
    score += 1;
  }
  if ((/\d/).test(value)) {
    score += 1;
  }
  if ((/[^A-Za-z0-9]/).test(value)) {
    score += 1;
  }

  return Math.min(score, 4);
}

/**
 * Compact 4-segment password strength indicator. Display-only — pass the current
 * password `value`. Hidden until the user types.
 */
const PasswordStrengthMeter = React.forwardRef((props, ref) => {
  const { value = '', className } = props;
  const score = scorePassword(value);
  const level = LEVELS[score];

  if (!value) {
    return null;
  }

  return (
    <div ref={ref} className={cn('flex items-center gap-2', className)}>
      <div className="flex flex-1 gap-1">
        {[1, 2, 3, 4].map((segment) => (
          <span
            key={segment}
            className={cn(
              'h-1 flex-1 rounded-full transition-colors',
              segment <= score ? level.bar : 'bg-hairline-strong',
            )}
          />
        ))}
      </div>

      <span className={cn('w-10 text-right text-xs font-medium', level.text)}>
        {level.label}
      </span>
    </div>
  );
});

PasswordStrengthMeter.displayName = 'PasswordStrengthMeter';

export { PasswordStrengthMeter };
export default PasswordStrengthMeter;
